import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { FeatureFlagGuardService } from "@pulse/common";
import { features, parentFeature, capabilites } from "@pulse/common";
import { EditDistributionGroupComponent, DistributionGroupAuditTrailComponent } from "@pulse/contacts";
// import { CustomPreloadingStrategyService } from './preloading-strategy.service';
const routes: Routes = [
  {
    path: 'marketing',
    loadComponent: () => import('./marketing-page/pulse-marketing/pulse-marketing.component').then(m => m.PulseMarketingComponent),
    data: { fullPage: true }
  },
  {
    path: "properties",
    loadChildren: () => import('./properties/properties.module').then(m => m.PropertiesModule),
    canActivate: [FeatureFlagGuardService],
    data: {
      featureFlag: capabilites.DASHBOARD,
      subFeatureFlag: features.PROPSOVERVIEW
    },
  },
  {
    //path: 'distribution-group/edit-dg/:dgid',
    path: "propertydetail/:id/contacts/edit-dg/:dgid",
    loadChildren: () => import('./distribution-group/distribution-group.module').then(m => m.DistributionGroupModule),
    canActivate: [FeatureFlagGuardService],
    data: {
      featureFlag: capabilites.DASHBOARD,
      subFeatureFlag: parentFeature.PROPERTYCONTACTS
    },
  },
  {
    //path: 'distribution-group/edit-dg/:dgid',
    path: "communication/distribution-group/edit-dg/:dgid",
    loadChildren: () => import('./distribution-group/distribution-group.module').then(m => m.DistributionGroupModule),
    canActivate: [FeatureFlagGuardService],
    data: {
      featureFlag: capabilites.DASHBOARD,
      subFeatureFlag: parentFeature.PROPERTYCONTACTS,
    },
  },
  {
    //path: 'distribution-group/edit-dg/:dgid',
    path: "communication/distribution-group/audittrail/:dgid",
    component: DistributionGroupAuditTrailComponent,
    canActivate: [FeatureFlagGuardService],
    data: {
      featureFlag: capabilites.DASHBOARD,
      subFeatureFlag: parentFeature.PROPERTYCONTACTS
    },
  },
  {
    path: "mail",
    loadChildren: () => import('./mail-module/mail-module.module').then(m => m.ContactsMailModuleModule),
    canActivate: [FeatureFlagGuardService],
    data: {
      featureFlag: capabilites.DASHBOARD
    },
  },
  {
    path: "analytics",
    loadChildren: () => import('./bi-analytics/analytics-bi.module').then(m => m.BIAnalyticsModule),
    canActivate: [FeatureFlagGuardService],
    data: { featureFlag: parentFeature.BI_ANALYTICS },
  },
  {
    path: "settings",
    loadChildren: () => import('./settings/settings.module').then(m => m.SettingsModule),
    canActivate: [FeatureFlagGuardService],
    data: { featureFlag: parentFeature.SETTINGS },
  },
  {
    path: "metrics",
    loadChildren: () => import('./metrics/metrics-bi.module').then(m => m.PulseUIMetricsModule),
    canActivate: [FeatureFlagGuardService],
    data: {
      featureFlag: parentFeature.BI_COMPLIANCE
    },
  },
  {
    path: "eom-variance",
    loadChildren: () => import('./reports/reports.module').then(m => m.ReportsModule),
    canActivate: [FeatureFlagGuardService],
    data: { featureFlag: capabilites.BUSINESSMANAGEMENT },
  },
  {
    path: 'pricing-governance',
    loadChildren: () => import('./reports/pricing-governance.module').then(m => m.PricingModule),
    canActivate: [FeatureFlagGuardService],
    data: { featureFlag: capabilites.BUSINESSMANAGEMENT },
  },
    {
      path: 'corporate-open-ar-tracker',
      loadChildren: () => import('./corporate-open-ar-tracker/corporate-open-ar-tracker.module').then(m => m.CorporateOpenArTrackerModule),
      canActivate: [FeatureFlagGuardService],
      data: { featureFlag: capabilites.BUSINESSMANAGEMENT },
  },
  {
    path: "eom-variance/dashboard",
    loadComponent: () => import('./powerbi/cbre-metrics/cbre-metrics.component').then(m => m.CBREMetricsComponent),
    canActivate: [FeatureFlagGuardService],
    data: { featureFlag: capabilites.BUSINESSMANAGEMENT, report: "Variance Dashboard" },
  },
  {
    path: "Forms",
    loadChildren: () => import('./utilities/pulse-utilities.module').then(m => m.FormUtilitiesModule),
    canActivate: [FeatureFlagGuardService],
    data: { featureFlag: capabilites.WOKRFLOW},
  },
  {
    path: "Forms/captrax-metrics",
    loadComponent: () => import('./powerbi/cbre-metrics/cbre-metrics.component').then(m => m.CBREMetricsComponent),
    canActivate: [FeatureFlagGuardService],
    data: { featureFlag: capabilites.WOKRFLOW, report: "CAPTRAX DASHBOARD" },
  },
  {
    path: "metrics/e4e_dashboard",
    loadComponent: () => import('./powerbi/e4e-dashboard/e4e-dashboard.component').then(m => m.E4EDashboardComponent),
    canActivate: [FeatureFlagGuardService],
    data: { featureFlag: capabilites.BIMETRICS, subFeatureFlag: features.E4E_DASHBOARD },
  },
  {
    path: "propertydetail/:id",
    loadChildren: () => import('./property/property.module').then(m => m.PropertyModule),
    canActivate: [FeatureFlagGuardService],
    data: {
      featureFlag: capabilites.DASHBOARD,
      subFeatureFlag: parentFeature.PROPERTY,
      preload: true
    },
  },
  {
    path: "admin",
    loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule),
    canActivate: [FeatureFlagGuardService],
    data: { featureFlag: capabilites.ADMIN },
  },
  {
    path: "admin/pc/send-notification",
    loadChildren: () => import('./pc-admin/pc-admin.module').then(m => m.PCAdminModule),
    canActivate: [FeatureFlagGuardService],
    data: { featureFlag: capabilites.ADMIN },
  },
  {
    path: "admin/templates-mgmt",
    loadChildren: () => import('./admin-templates/admin-templates.module').then(m => m.AdminTemplatesModule),
    canActivate: [FeatureFlagGuardService],
    data: { featureFlag: capabilites.ADMIN },
  },
  {
    path: "wiki",
    loadChildren: () => import('./wiki/wiki.module').then(m => m.WikiModule),
    canActivate: [FeatureFlagGuardService],
    data: { featureFlag: capabilites.PROPERTYGROUP },
  },
  {
    path: "powerbi/engineering_score_card",
    loadComponent: () => import('./powerbi/cbre-metrics/cbre-metrics.component').then(m => m.CBREMetricsComponent),
    canActivate: [FeatureFlagGuardService],
    data: { featureFlag: capabilites.BUSINESSMANAGEMENT, report: "Engineering Score Card" }
  },
  {
    path: "powerbi",
    loadChildren: () => import('./powerbi/powerbi.module').then(m => m.PowerBiModule),
    canActivate: [FeatureFlagGuardService],
    data: { featureFlag: capabilites.CBRE_METRICS },
  },
  {
    path: "admin/pulse-stats",
    loadComponent: () => import('./powerbi/cbre-metrics/cbre-metrics.component').then(m => m.CBREMetricsComponent),
    canActivate: [FeatureFlagGuardService],
    data: { featureFlag: capabilites.ADMIN, report: "Pulse Stats" },
  },
  {
    path: "vts-lease-insights",
    loadComponent: () => import('./powerbi/cbre-metrics/cbre-metrics.component').then(m => m.CBREMetricsComponent),
    canActivate: [FeatureFlagGuardService],
    data: { featureFlag: capabilites.VTS_DASHBOARD, report: "vts lease insights" },
  },
   {
    path: "kpi-dashboard",
    loadComponent: () => import('./powerbi/cbre-metrics/cbre-metrics.component').then(m => m.CBREMetricsComponent),
    canActivate: [FeatureFlagGuardService],
    data: { featureFlag: capabilites.BUSINESSMANAGEMENT, report: "kpi-dashboard"}
   },
    {
    path: "opx-analysis",
    loadComponent: () => import('./powerbi/cbre-metrics/cbre-metrics.component').then(m => m.CBREMetricsComponent),
    canActivate: [FeatureFlagGuardService],
    data: { featureFlag: capabilites.MARKET_INTELLIGENCE, report: "OPX Analysis" }
  },
  {
    path: "client-intelligence-dashboard",
    loadComponent: () => import('./powerbi/cbre-metrics/cbre-metrics.component').then(m => m.CBREMetricsComponent),
    canActivate: [FeatureFlagGuardService],
    data: { featureFlag: capabilites.MARKET_INTELLIGENCE, report: "Client Intelligence Dashboard" }
  },
  {
    path: "portfolio",
    loadChildren: () => import('./portfolio/powerbiportfolio.module').then(m => m.PowerBiPortfolioModule),
    canActivate: [FeatureFlagGuardService],
    data: { featureFlag: capabilites.PORTFOLIODASHBOARD }
  },
  {
    path: "tableau",
    loadChildren: () => import('./tableau-reports/tableau/tableau.module').then(m => m.TableauModule),
    canActivate: [FeatureFlagGuardService],
    data: { featureFlag: capabilites.DASHBOARD },

  },
  {
    path: "market-intelligence",
    loadChildren: () => import('./market-intelligence/market-intl-landing/marketintel.module').then(m => m.MarketIntleModule),
    canActivate: [FeatureFlagGuardService],
    data: { featureFlag: capabilites.MARKET_INTELLIGENCE },

  },
    {
    path: "cbre-business-mgmt",
    loadChildren: () => import('./cbre-business-mgmt/cbre-business-mgmt.module').then(m => m.CBREBusinessMGMTModule),
  },
  // {
  //   path: "cbre-business-mgmt",
  //   loadChildren: () => import('./cbre-business-mgmt/cbre-business-mgmt.module').then(m => m.CBREBusinessMGMTModule),
  //   canActivate: [FeatureFlagGuardService],
  //   data: { featureFlag: capabilites.BUSINESSMANAGEMENT },

  // },
  {
    path: "dataroom",
    loadChildren: () => import('./dataroom/dataroom.module').then(m => m.DataRoomModule),
    canActivate: [FeatureFlagGuardService],
    data: { featureFlag: capabilites.DATAROOM },
  },
  {
    path: "transition-checklist",
    loadComponent: () => import('./transition-checklist/transition-checklist.component').then(m => m.TransitionChecklistComponent),
    canActivate: [FeatureFlagGuardService],
    data: { featureFlag: capabilites.TRANSITION_CHECKLIST },
  },
  {
    path: "unauthorized",
    loadComponent: () => import('./shared/unauthorized/unauthorized.component').then(m => m.UnauthorizedComponent)
  },
  {
    path: "",
    redirectTo: "/properties/dashboard",
    pathMatch: "full",
  },
  {
    path: "interstitial",
    loadChildren: () => import('./interstitial/interstitial.module').then(m => m.InterstitialModule),
  },
  {
    path: "my-profile",
    loadChildren: () => import('./profile/profile.module').then(m => m.ProfileModule),
    canActivate: [FeatureFlagGuardService],
    data: { featureFlag: capabilites.PROPERTYGROUP },
  },
  {
    path: "document",
    loadChildren: () => import('./documents/documents.module').then(m => m.DocumentsModule),
    canActivate: [FeatureFlagGuardService],
    data: { featureFlag: capabilites.PROPERTYGROUP},
  },
  {
    path: "tenantdetail/:tenantId",
    loadChildren: () => import('./tenant-detail/tenant-detail.module').then(m => m.TenantDashboardModule),
    canActivate: [FeatureFlagGuardService],
    data: { featureFlag: capabilites.DASHBOARD },
  },
  {
    path: "k2/generic-form",
    loadComponent: () => import('./k2/generic-form/generic-form.component').then(m => m.GenericFormComponent),
    canActivate: [FeatureFlagGuardService],
    data: { featureFlag: capabilites.PROPERTYGROUP },
  },
  {
    path: "k2/property-attributes",
    loadComponent: () => import('./k2/k2-property-attributes-form/k2-property-attributes-form.component').then(m => m.K2PropertyAttributesFormComponent),
    canActivate: [FeatureFlagGuardService],
    data: { featureFlag: capabilites.PROPERTYGROUP },
  },
  {
    path: "digital-services",
    loadChildren: () => import('./onboard/digital-services.module').then(m => m.DigitalServicesModule),
    canActivate: [FeatureFlagGuardService],
    data: { featureFlag: capabilites.DIGITAL_SERVICES },
  },
  {
    path: 'chatbot',
    loadChildren: () => import('./chatbot-module/chatbot.module').then(m => m.ChatbotModule),
    canActivate: [FeatureFlagGuardService],
    data: { featureFlag: capabilites.GLOBAL_SEARCH },
  },
  {
    path: 'global-search',
    loadChildren: () => import('./global-search/global-search.module').then(m => m.GlobalSearchModule),
    canActivate: [FeatureFlagGuardService],
    data: { featureFlag: capabilites.GLOBAL_SEARCH },
  },
  {
    path: "datastewardship",
    loadChildren: () => import('./onboard/datastewardship.module').then(m => m.DataStewardshipModule),
    canActivate: [FeatureFlagGuardService],
    data: { featureFlag: capabilites.BUSINESSMANAGEMENT },
  },
  { path: 'globalstandards', loadChildren: () => import('./palantir/palantir.module').then(m => m.PalantirModule),
    canActivate: [FeatureFlagGuardService],
    data: {
      featureFlag: capabilites.DASHBOARD,
      subFeatureFlag: features.PROPSOVERVIEW,
    },
  },
  { path: "**", redirectTo: "/properties/dashboard" },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
